export default [
  {
    label: 'LEI Code',
    type: 'STRING',
    text: 'LEI Code',
    fieldId: 'LEIREC_LEI',
    jsonPath: '$.lei',
  },
]



// WEBPACK FOOTER //
// ./src/utils/challenge/lei-code.js